export default (frameIndex, start, distance, numberOfFrames) => {
	frameIndex /= numberOfFrames / 2;
	if (frameIndex < 1) {
		return (distance / 2) * Math.pow(frameIndex, 3) + start;
	}
	frameIndex -= 2;
	return Math.round((distance / 2) * (Math.pow(frameIndex, 3) + 2) + start);
};
